import styled from "styled-components";

interface FilterButtonProps {
    active?: boolean;
}
export const FilterButton = styled.button<FilterButtonProps>`
    color: ${ ({active}) => active ? "white" : "#bdafad"};
    margin-right: 5px;
    padding: 0.05rem 0.65rem;
    font-size: .75rem;
    &:hover {
        color: white;
    }
`